
import XTextarea from 'vux/src/components/x-textarea/index.vue'

export default {
components: {XTextarea},
name: "feedback",
data() {
return {
value:''
}
},
methods: {
save(){
console.log(this.value);
},
backLastPage(){
if (this.$store.state.device === 'wap') {
this.$router.go(-1);
} else {
document.location = "http://action:10002/?";
}
},
}
}



// WEBPACK FOOTER //
// ./src/page/home/feedback.vue